module.exports = __webpack_public_path__ + "img/res7.04cc1841.jpg";